import { GeoJsonLayer } from '@deck.gl/layers';
import type { LayerProps } from '@deck.gl/core';
import { CompositeLayer } from '@deck.gl/core';
import uniqBy from 'lodash/uniqBy';
import { LayerType } from './types';
import type { Feature } from 'geojson';

export const satelliteImageGeomLayer = 'satellite_image_geom';
export const satelliteImageBboxLayer = 'satellite_image_bbox';

export const getSatelliteBaseSubLayers = (data: Feature[]) => {
  return new SatelliteMetadataSubLayer({
    id: LayerType[LayerType.satellite_metadata_sub],
    data,
  });
};

type FeatureProps = {
  data: Feature[];
} & LayerProps;

class SatelliteMetadataSubLayer extends CompositeLayer<FeatureProps> {
  static layerName: string;
  constructor(props: FeatureProps) {
    super(props);
  }

  renderLayers() {
    const { data } = this.props;

    return [
      new GeoJsonLayer({
        id: satelliteImageGeomLayer,
        data,
        pickable: true,
        filled: true,
        opacity: 0,
      }),

      new GeoJsonLayer<Feature>({
        id: satelliteImageBboxLayer,
        data,
        dataTransform: <LayerDataT = Feature[]>(data: unknown): LayerDataT => {
          const features = data as Feature[];
          const bbox_layers = features.map((d) => ({
            properties: d.properties,
            geometry: JSON.parse(d.properties?.bbox),
          }));
          return uniqBy(bbox_layers, 'properties.bbox') as LayerDataT;
        },
        pickable: true,
        filled: true,
        opacity: 0,
      }),
    ];
  }
}

SatelliteMetadataSubLayer.layerName = 'SatelliteMetadataSubLayer';
